import { useEffect } from "react";
import { Platform } from "react-native";
import { MessageOptions, showMessage } from "react-native-flash-message";
import useNavigation from "./useNavigation";
import useSyncFilterWithParam from "./useSyncFilterWithParam";
import useSaveBasket from "../hooks/useSaveBasket";
import {
  EVENT_TYPES,
  logEvent,
  logMetrixEvent,
  METRIX_EVENT_TYPES,
} from "../helpers/analytics-helper";
import { services_to_ga_cart } from "../helpers/ga-helper";
import { CartRetrieveOutput } from "../ducks/cart/cart-types";

function message(messageType: string): MessageOptions {
  if (messageType === "payment_success") {
    return {
      message: "پرداخت با موفقیت انجام شد.",
      type: "success",
    };
  }
  if (messageType === "payment_failed") {
    return {
      message: "پرداخت انجام نشد.",
      type: "danger",
    };
  } else
    return {
      message: "پرداخت با خطا مواجه شده است",
      type: "danger",
    };
}
function checkParams(params, key) {
  if (!params) return;
  let hasNestedParam = !!params?.params;
  let value = params[key];
  if (!value && hasNestedParam) {
    value = params.params[key];
  }
  return value;
}
export function useListenToDeepLinks() {
  let { params, reset } = useSyncFilterWithParam();
  let nav = useNavigation();
  let go = checkParams(params, "go");
  let messageType = checkParams(params, "message_type");
  let orderId = checkParams(params, "order_id");
  let addressId = checkParams(params, "address_id");
  let periodId = checkParams(params, "period_id");

  let { save } = useSaveBasket("collection", {
    order_id: Number(orderId),
  });

  function check_and_save_collection(options?: {
    cart?: CartRetrieveOutput;
    needsToPay?: boolean;
  }) {
    let { needsToPay, cart } = options || {};
    let cartData = cart?.data;

    if (periodId && addressId && orderId && !needsToPay) {
      save({
        address_id: Number(addressId),
        period_id: Number(periodId),
      }).then(() => {
        let event_meta = {};
        logEvent(
          EVENT_TYPES.BEGIN_CHECKOUT,
          services_to_ga_cart(
            cartData.legacyQuote.total_price,
            cartData.services,
            cartData.legacyPromotion?.code
          )
        );
        logMetrixEvent(METRIX_EVENT_TYPES.COLLECTION, event_meta);
      });
    } else {
      if (!!addressId) {
        reset("address_id");
      }
      if (!!periodId) {
        reset("period_id");
      }
      if (!!orderId) {
        reset("order_id");
      }
    }
  }
  useEffect(() => {
    if (Platform.OS === "android" && !!go) {
      let screenParams: {
        payment_status: string;
        order_id?: string;
        address_id?: string;
        period_id?: string;
      } = {
        payment_status: messageType,
      };
      if (!!orderId) {
        screenParams.order_id = orderId;
      }
      if (!!addressId) {
        screenParams.address_id = addressId;
      }
      if (!!periodId) {
        screenParams.period_id = periodId;
      }

      nav.navigate(go, screenParams);
    }
  }, [go]);
  useEffect(() => {
    if (!!messageType) {
      if (messageType === "payment_success") {
        showMessage(message("payment_success"));
      }
      if (messageType === "payment_failed") {
        showMessage(message("payment_failed"));
      }

      reset("message_type");
    }
  }, [messageType]);

  return {
    check_and_save_collection,
  };
}
